import * as React from 'react';

type IMapPinIconProps = React.SVGProps<SVGSVGElement>;

const MapPinIcon: React.FunctionComponent<IMapPinIconProps> = ({
  width = 24,
  height = 24,
  color = '#fff',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 47 47'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clip-path='url(#clip0_1645_2143)'>
        <path
          d='M23.3809 5.84375C26.5595 5.84376 29.6667 6.8079 32.3097 8.61426C34.9527 10.4208 37.0131 12.989 38.2296 15.9932C39.446 18.9973 39.7647 22.303 39.1446 25.4922C38.5245 28.6814 36.9937 31.6108 34.7462 33.9102L26.2218 42.6299C25.4684 43.3998 24.4469 43.833 23.3819 43.833C22.317 43.833 21.2955 43.3998 20.5421 42.6299L12.0157 33.9102C9.76812 31.6108 8.23735 28.6814 7.61727 25.4922C6.9972 22.303 7.31587 18.9973 8.53231 15.9932C9.74877 12.9891 11.8083 10.4208 14.4513 8.61426C17.0943 6.80772 20.2022 5.84375 23.3809 5.84375ZM23.38 17.5332C20.9591 17.5332 18.9962 19.4961 18.9962 21.917C18.9964 24.3376 20.9593 26.2998 23.38 26.2998C25.8005 26.2996 27.7625 24.3375 27.7628 21.917C27.7628 19.4963 25.8006 17.5334 23.38 17.5332Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_1645_2143'>
          <rect width='46.7556' height='46.7556' fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapPinIcon;
